.revision-confirmation-modal__list {
  margin: 0.5rem 0;
  padding-left: 1.5rem;
  line-height: 1.6;
}

.revision-confirmation-modal__list li {
  margin-bottom: 0.5rem;
}

.revision-confirmation-modal__container,
.revision-confirmation-modal__container ion-list {
  height: 100%;
}
